import { React, useState, useRef } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  CardMedia,
  Typography,
  makeStyles,
  Paper,
  Box,
} from "@material-ui/core";
import QRCode from "qrcode.react";
import PublishIcon from "@material-ui/icons/Publish";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

import SFDialogTitle from "../../../../../components/SFDialogTitle";
import BankSelector from "../Widget/BankSelector";
import PreviewImage from "./PreviewImage";
import { PaymentChannel } from "../../../../../models/Payment";
import usePaymentChannels from "../../../../../hooks/usePaymentChannels";
import CustomerBankSelectField from "../Widget/CustomerBankSelectField";
import { useTranslate } from "react-admin";
import useSFAlert from "../../../../../hooks/useSFAlert";
const useStyles = makeStyles((theme) => ({
  paper: {
    margin: "50px auto",
    width: 668,
    maxWidth: 1200,

    borderRadius: "10px",
  },
  dialogContainer: {
    margin: "0 auto",
  },
  payment: {
    color: theme.orange,
    fontSize: 30,
    fontWeight: "bold",

    margin: "20px auto 0",
    display: "table",
  },

  buttonTakePhoto: {
    width: 287,
    height: 55,
    backgroundColor: theme.orange,
    border: "1px  #828282",
    borderRadius: 7,
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  },
  textButtonTakePhoto: {
    color: "white",
  },
  topicBank: {
    fontSize: 16,
    fontWeight: "bold",
    margin: "15px 0 0px 0",
  },
  detailBank: {
    fontSize: 24,
    fontWeight: "bold",
    fontStyle: "normal",
    color: theme.orange,
    lineHeight: 1,
  },
  uploadContainer: {
    marginTop: 5,
    display: "grid",
    gridTemplateColumns: "auto 228px",
    justifyItems: "start",
  },
  correctMini: {
    width: 21,
    height: 21,
    margin: 5,
  },
  selectCustomerBankContainer: {
    width: 228,
    height: 55,
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
  },
}));

function TransferPage({
  openDialog,
  handleDialogClose,
  onSubmit,
  paymentValue,
}) {
  const classes = useStyles();
  const [alert] = useSFAlert();
  const { transfers, banks, loading, getDefaultBank } = usePaymentChannels();
  const [selectedBank, setSelectedBank] = useState(null);
  const [selectedImage, setImage] = useState("#");
  const [isAttach, setIsAttach] = useState(false);
  const [selectedSenderBank, setSelectedSenderBank] = useState(null);
  const translate = useTranslate();
  if (loading) return null;

  const bankList = transfers.map((transfer) => {
    return {
      id: transfer.id,
      icon: transfer.institute.image_url,
      instituteId: transfer.institute?.id,
      bankName: `${transfer.institute?.name} (${transfer.account_name})`,
      accountName: transfer.account_name,
      accountNumber: transfer.account_no,
      qrData: transfer.action_code,
      color: banks.find((bank) => bank.id === transfer.institute?.id)
        ?.font_color,
      baseQrCode: {
        text: transfer.institute?.name,
        color: "#ffffff",
      },
    };
  });

  const handleBankChange = (value) => {
    if (!value) {
      return;
    }
    setSelectedBank(value);
  };

  const handleAttachPhoto = () => {
    setIsAttach(true);
  };

  const handleButton = async () => {
    if (isAttachPhotoPage()) {
      handleAttachPhoto();
    } else {
      const payment = new PaymentChannel({
        type: "Transfer",
        amount: paymentValue,
        instituteId: selectedSenderBank
          ? selectedSenderBank.id
          : getDefaultBank().id,
        instituteName: selectedSenderBank
          ? selectedSenderBank.name
          : getDefaultBank().name,
        image: selectedImage,
        // senderInstituteId: selectedSenderBank.id,
        // senderInstituteName: selectedSenderBank.name,
      });
      onSubmit(payment);
    }
  };

  const onChangeSelectImageHandler = (file) => {
    //Simple Validate image 10000000
    if (file.size > 10000000) {
      alert("File size is too large " + file.size);
      return;
    }
    setIsAttach(false);

    setImage({
      rawFile: file,
      src: URL.createObjectURL(file),
      title: "receipt",
    });
  };

  const isAttachPhotoPage = () => selectedImage !== "#" && isAttach === false;

  return (
    <Dialog
      fullWidth
      onClose={() => {
        handleDialogClose();
        setSelectedBank(null);
        
      }}
      aria-labelledby="customized-dialog-title"
      open={openDialog}
      classes={{ root: classes.dialogContainer, paper: classes.paper }}
      // style={{}}
    >
      <SFDialogTitle
        title={translate("ra.text.paymentMethod.paidbyTransfer")}
        onClose={() => {
          handleDialogClose();
          setSelectedBank(null)
        }}
      />

      {isAttachPhotoPage() ? (
        <PreviewImage image={selectedImage.src} />
      ) : (
        <DialogContent style={{ margin: "0 auto 10px" }}>
          <Typography className={classes.topicBank} gutterBottom>
            1. {translate("ra.text.paymentMethod.selectSellerBank")}
          </Typography>
          <BankSelector
            onChange={(value) => handleBankChange(value)}
            bankSeller={bankList}
            selectedBank={selectedBank}
          />

          <Typography className={classes.topicBank} gutterBottom>
            2. {translate("ra.text.paymentMethod.transferTo")}
          </Typography>
          {selectedBank === null ? (
            <Paper
              style={{
                borderRadius: 8,
                backgroundColor: "rgb(250,153,23,0.1)",
                width: 528,
                height: 228,
                marginTop: 5,
                border: "1px solid #EBEBEB",
              }}
            ></Paper>
          ) : (
            <Paper
              style={{
                borderRadius: 8,
                backgroundColor: "rgb(250,153,23,0.1)",
                width: 528,
                height: 228,
              }}
            >
              <Box
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                }}
              >
                <Box
                  style={{
                    margin: "10px auto 0",
                  }}
                >
                  {selectedBank?.qrData ? (
                    <QRCode
                      value={selectedBank?.qrData ?? ""}
                      style={{
                        margin: "0px auto",
                        width: 180,
                        height: 180,
                        backgroundColor: "transparent",
                        alignContent: "center",
                      }}
                    ></QRCode>
                  ) : (
                    <Box
                      style={{
                        margin: "0px auto",
                        width: 180,
                        height: 180,
                        backgroundColor: "white",
                        alignContent: "center",
                        display: "grid",
                        placeItems: "center",
                      }}
                    >
                      <Typography variant="h6">No QR</Typography>
                    </Box>
                  )}

                  <Typography
                    align="center"
                    style={{
                      backgroundColor: selectedBank.color,
                      color: "white",
                      fontSize: 20,
                    }}
                  >
                    {selectedBank?.baseQrCode.text}
                  </Typography>
                </Box>

                <Box style={{ margin: "25px 100px 20px 10px" }}>
                  <Typography className={classes.topicBank}>{}</Typography>

                  <Box style={{ display: "flex", flexWrap: "wrap" }}>
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: 150,
                      }}
                    >
                      <CardMedia
                        image={selectedBank?.icon}
                        style={{ width: 35, height: 35 }}
                      />
                      <Typography
                        align="left"
                        style={{ fontSize: 10, marginLeft: 11 }}
                      >
                        {selectedBank?.bankName}
                      </Typography>
                    </Box>
                  </Box>

                  <Typography className={classes.topicBank}>
                    {translate("ra.text.paymentMethod.accountName")}
                  </Typography>
                  <Typography className={classes.detailBank}>
                    {selectedBank?.accountName}
                  </Typography>
                  <Typography className={classes.topicBank}>
                    {translate("ra.text.paymentMethod.accountNumber")}
                  </Typography>
                  <Typography className={classes.detailBank}>
                    {selectedBank?.accountNumber}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          )}
          <Typography className={classes.topicBank}>
            3. {translate("ra.text.paymentMethod.selectBank")}
          </Typography>
          <Box className={classes.uploadContainer}>
            <Box className={classes.selectCustomerBankContainer}>
              <CustomerBankSelection
                banks={banks}
                selectedSenderBank={selectedSenderBank}
                setSelectedSenderBank={setSelectedSenderBank}
              />
            </Box>
            <ImageUploadButton
              uploaded={selectedImage}
              disabled={!selectedSenderBank}
              onChange={onChangeSelectImageHandler}
            />
          </Box>
        </DialogContent>
      )}

      <Button
        autoFocus
        variant="contained"
        color="primary"
        disabled={
          isAttachPhotoPage() ? selectedSenderBank === null : false //selectedBank === null || selectedSenderBank === null
        }
        onClick={handleButton}
        style={{
          // alignContent: "center",
          borderRadius: 0,
          height: 69,
          fontSize: 26,
        }}
      >
        <Typography align="center" style={{ color: "white", fontSize: 26 }}>
          {isAttachPhotoPage()
            ? translate("ra.text.paymentMethod.attachPhoto")
            : translate("ra.text.paymentMethod.pay")}
        </Typography>
      </Button>
    </Dialog>
  );
}

const useImageUploadButtonStyle = makeStyles((theme) => ({
  button: {
    width: 228,
    height: 55,
    fontSize: 18,
  },
  uploaded: {
    width: 228,
    height: 55,
    fontSize: 18,
    backgroundColor: theme.white,
    color: theme.darkGray,
  },
}));

const ImageUploadButton = ({ uploaded = null, onChange, disabled }) => {
  const input = useRef();
  const classes = useImageUploadButtonStyle();
  const translate = useTranslate();
  const handleClick = () => input.current.click();
  return (
    <>
      <input
        disabled={disabled}
        accept="image/jpg, image/gif, image/jpeg, image/png"
        ref={input}
        type="file"
        style={{ display: "none" }}
        onChange={(e) => onChange(e.target.files[0])}
      />
      <label htmlFor="contained-button-file">
        <Button
          disabled={disabled}
          className={uploaded?.src ? classes.uploaded : classes.button}
          onClick={handleClick}
          variant="contained"
          color="primary"
          startIcon={
            uploaded?.src ? (
              <CheckCircleIcon style={{ color: "green" }} />
            ) : (
              <PublishIcon />
            )
          }
        >
          {uploaded?.src
            ? "file-name.jpg"
            : translate("ra.text.paymentMethod.attachReceipt")}
        </Button>
      </label>
    </>
  );
};

const CustomerBankSelection = ({
  banks,
  selectedSenderBank,
  setSelectedSenderBank,
}) => {
  return (
    <CustomerBankSelectField
      options={banks}
      value={selectedSenderBank}
      onChange={setSelectedSenderBank}
    />
  );
};

export default TransferPage;
